<template>
    <div v-if="value" class="left-area-item">
        <span class="text" v-html="text"></span><br />
        <span class="value">{{ formatThousand(value) }}</span>
    </div>
</template>

<script>

export default {
    name: 'LeftAreaItem',
    props: {
        text: String,
        value: [String, Number],
        last: Boolean
    },
    methods: {
        formatThousand(value) {
            if (typeof value === 'string') {
                return value;
            }
            value = value ? value.toString() : '';
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(value))
                value = value.replace(pattern, "$1.$2");
            return value;
        }
    }
}
</script>
<style scoped>
.left-area-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 30px;
}
.left-area-item:nth-child(odd) {
    background-image: linear-gradient(to left, var(--left-area-item-odd-gradient-1), var(--left-area-item-odd-gradient-2));
}

.text {
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    color: #fff;
}

.value {
    font-size: 17px;
    font-weight: bold;
    text-align: left;
    color: #fff;
}
</style>